import * as query from "query-string";
import * as _ from "lodash";
class UrlUtils {
  getUserContextFromUrl(userContextParams, queryString) {
    const qsNameValues = query.parse(queryString);
    const resultUserContextObj = {};
    _.each(qsNameValues, (qsValue, qsName) => {
      const specItem = userContextParams[qsName];
      if (specItem) {
        let userContextParamValue;
        if (specItem.paramType === "enum") {
          if (!specItem.isMultiValue) {
            userContextParamValue = _.includes(specItem.validEnumValues, qsValue) ? qsValue : null;
          } else {
            const items = qsValue ? qsValue.split(",") : null;
            if (items) {
              userContextParamValue = specItem.allowAnyEnumValues ? items : _.filter(items, (i) => _.includes(specItem.validEnumValues, i));
            } else if (specItem.defaultValue && specItem.defaultValue.length) {
              userContextParamValue = [];
            } else {
              userContextParamValue = null;
            }
          }
        } else {
          if (specItem.paramType === "number") {
            if (_.isNil(qsValue) || qsValue.trim() == "") {
              userContextParamValue = null;
            } else {
              const asNumber = +qsValue;
              if (_.isNaN(asNumber)) {
                userContextParamValue = null;
              } else {
                userContextParamValue = asNumber;
              }
            }
          } else if (specItem.paramType === "date") {
            if (_.isNil(qsValue) || qsValue.trim() == "") {
              userContextParamValue = null;
            } else {
              const asDate = new Date(qsValue);
              if (_.isNaN(asDate.getTime())) {
                userContextParamValue = null;
              } else {
                userContextParamValue = asDate;
              }
            }
          } else if (specItem.paramType == "boolean" || specItem.paramType == "tristate") {
            if (specItem.paramType == "boolean") {
              userContextParamValue = qsValue === "true";
            } else {
              userContextParamValue = qsValue === "true" ? true : qsValue.trim() == "" ? null : qsValue === "false" ? false : null;
            }
          } else {
            userContextParamValue = qsValue;
          }
        }
        if (userContextParamValue !== void 0) {
          const userContextStoreParamName = specItem.storeParamName || qsName;
          resultUserContextObj[userContextStoreParamName] = userContextParamValue;
        }
      }
    });
    _.each(userContextParams, (userContextParam, userContextParamName) => {
      if (qsNameValues[userContextParamName] === void 0) {
        let userContextParamValue;
        if (userContextParam.paramType == "boolean") {
          userContextParamValue = userContextParam.defaultValue || false;
        } else {
          userContextParamValue = userContextParam.defaultValue !== void 0 ? userContextParam.defaultValue : null;
        }
        if (userContextParamValue !== void 0) {
          const userContextStoreParamName = userContextParam.storeParamName || userContextParamName;
          resultUserContextObj[userContextStoreParamName] = userContextParamValue;
        }
      }
    });
    return resultUserContextObj;
  }
  getKeyValuePair(userContextParam, value, key) {
    const outValue = userContextParam.paramType === "enum" && userContextParam.isMultiValue ? _.map(value, (e) => encodeURIComponent(e)).join(",") : encodeURIComponent(value);
    return `${key}=${outValue}`;
  }
  getUserContextItemsThatAreSet(userContextParams, userContext, qsNameFromStoreName) {
    return _.pickBy(userContext, (userContextValue, userContextStoreName) => {
      const userContextParam = userContextParams[qsNameFromStoreName[userContextStoreName]];
      if (userContextParam === void 0) {
        throw `key: ${userContextStoreName} as key/storeParamName found in userContext, but not in userContextParams.  Is it missing in the UserContextParams configuration? userContextParams: ${JSON.stringify(
          userContextParams,
          null,
          2
        )}`;
      }
      if (userContextParam.paramType === "enum" && userContextParam.isMultiValue) {
        const hasValue = userContextValue && userContextValue.length;
        const userContextDefaultValue = userContextParam.defaultValue;
        const userContextValueEqualLengthOfDefault = userContextValue && userContextParam.defaultValue && userContextValue.length === userContextDefaultValue.length;
        const sameUserContextValueAndDefault = userContextValueEqualLengthOfDefault && _.difference(userContextDefaultValue, userContextValue).length === 0;
        const hasNoDefaultOrDefaultAndNotTheSame = userContextDefaultValue === void 0 || !sameUserContextValueAndDefault;
        const hasDefaultAndNotTheSame = userContextDefaultValue !== void 0 && !sameUserContextValueAndDefault;
        const hasValueAndHasNoDefaultOrDefaultAndNotTheSame = !!hasValue && hasNoDefaultOrDefaultAndNotTheSame;
        const notHasValueAndHasUserContextDefaultValue = !hasValue && hasDefaultAndNotTheSame;
        const showQueryStringParam = hasValueAndHasNoDefaultOrDefaultAndNotTheSame || notHasValueAndHasUserContextDefaultValue;
        return showQueryStringParam;
      } else if (userContextParam.paramType === "string") {
        if (userContextParam.defaultValue) {
          return userContextParam.defaultValue !== userContextValue.trim();
        } else {
          return userContextValue && userContextValue.trim();
        }
      } else if (userContextParam.paramType === "tristate") {
        return userContextValue === true || userContextValue === false;
      } else {
        if (userContextParam.defaultValue) {
          return userContextParam.defaultValue !== userContextValue;
        } else {
          return userContextValue;
        }
      }
    });
  }
  getUrlFromUserContext(userContextParams, additionalFixedParams, userContext, existingQueryString) {
    const queryString = existingQueryString.trim().replace(/^[?#&]/, "");
    const rawParts = !queryString ? [] : queryString.split("&");
    const existingQsNamesInOrder = _.map(rawParts, (p) => p.replace(/\+/g, " ").split("=")[0]);
    const existingQsNameValues = query.parse(existingQueryString);
    const qsNameFromStoreName = {};
    _.each(
      userContextParams,
      (userContextParam, userContextParamName) => qsNameFromStoreName[userContextParam.storeParamName || userContextParamName] = userContextParamName
    );
    const userContextItemsThatAreSet = this.getUserContextItemsThatAreSet(userContextParams, userContext, qsNameFromStoreName);
    const userContextItemsThatAreSetByQsName = {};
    _.each(userContextItemsThatAreSet, (v, k) => {
      const qsName = qsNameFromStoreName[k];
      userContextItemsThatAreSetByQsName[qsName] = v;
    });
    const additionalFixedParamsSet = _.filter(additionalFixedParams, (p) => _.includes(existingQsNamesInOrder, p));
    const qsNamesForContextItesmThatAreSet = _.keys(userContextItemsThatAreSetByQsName);
    const newProps = _.difference([...additionalFixedParamsSet, ...qsNamesForContextItesmThatAreSet], existingQsNamesInOrder);
    const allKvps = [];
    _.each(existingQsNamesInOrder, (qSName) => {
      const existingAdditionalFixedParam = existingQsNameValues[qSName];
      if (!userContextParams[qSName] && existingAdditionalFixedParam !== void 0 && _.includes(additionalFixedParams, qSName)) {
        if (existingAdditionalFixedParam !== null) {
          allKvps.push(`${qSName}=${existingAdditionalFixedParam}`);
        }
      } else {
        const userContextParam = userContextParams[qSName];
        const value = userContextParam && userContextItemsThatAreSetByQsName[qSName];
        if (value) {
          allKvps.push(this.getKeyValuePair(userContextParam, value, qSName));
        }
      }
    });
    _.each(newProps, (qsName) => {
      const userContextParam = userContextParams[qsName];
      allKvps.push(this.getKeyValuePair(userContextParam, userContextItemsThatAreSetByQsName[qsName], qsName));
    });
    return allKvps.join("&");
  }
}
const urlUtils = new UrlUtils();
export {
  urlUtils as default
};
//# sourceMappingURL=UrlUtils.js.map
